import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.JensenPhoneNumbers = routerStyxie({ actions: ['index', 'new', 'edit']})
